/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! Content Resonance — viewer.
 *  /content -> per-page table + headline ; /get?path=<path> -> page detail + device breakdown.
 *  Talks through the app's GS.api ({ok,status,data}). Deep-linkable via ?path=<path>.
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["content-resonance"] = "1.0.1"; } catch (e) {}
  if (window.__bcrWired) return; window.__bcrWired = 1;

  var root = document.querySelector('[data-cr="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-cr="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function iso(ms) { return new Date(ms).toISOString().slice(0, 10); }
  var RANGE = { from: iso(Date.now() - 30 * 86400000), to: iso(Date.now()) };
  function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
  function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
  function _rpPreset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
  var _RPL={label:null,preset:"30"};
  (function(){try{var s=JSON.parse(localStorage.getItem("gs_cr_range")||"null");if(s&&s.preset){var p=_rpPreset(+s.preset);RANGE.from=p.from;RANGE.to=p.to;_RPL.label=p.label;_RPL.preset=p.preset;}else if(s&&s.from&&s.to){RANGE.from=s.from;RANGE.to=s.to;_RPL.label=s.from+" \u2192 "+s.to;_RPL.preset=null;}}catch(e){}if(!_RPL.label){var d=_rpPreset(30);_RPL.label=d.label;}})();
  function _rpInit(){
    function _rpBtnLabel(menu,preset){if(!menu||!preset)return null;var b=menu.querySelector('.rm[data-preset="'+preset+'"]');return b?b.textContent.trim():null;}
    
    if(_RPL&&_RPL.preset){var _rp=_rpPreset(+_RPL.preset);_RPL.label=_rp.label;if(typeof RANGE!=="undefined"&&RANGE){RANGE.label=_rp.label;}}
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label");if(!btn||!menu)return;
    (function(){var _pp=(typeof RANGE!=="undefined"&&RANGE&&RANGE.preset)||(typeof _RPL!=="undefined"&&_RPL&&_RPL.preset);var _bl=_rpBtnLabel(menu,_pp);if(_bl){if(lab)lab.textContent=_bl;if(typeof RANGE!=="undefined"&&RANGE)RANGE.label=_bl;if(typeof _RPL!=="undefined"&&_RPL)_RPL.label=_bl;}})();
    if(lab&&_RPL.label)lab.textContent=_RPL.label;
    function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===_RPL.preset);});}
    btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
    document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
    function apply(o){ if(o&&o.preset){var _bl2=_rpBtnLabel(menu,o.preset);if(_bl2)o.label=_bl2;}RANGE.from=o.from;RANGE.to=o.to;_RPL.label=o.label;_RPL.preset=o.preset;if(lab)lab.textContent=o.label;try{localStorage.setItem("gs_cr_range",JSON.stringify({from:o.from,to:o.to,preset:o.preset}));}catch(e){}menu.style.display="none";loadContent();}
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(_rpPreset(+b.getAttribute("data-preset")));});});
    var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
  }
  function resColor(r) { return r >= 65 ? "#1FA463" : (r >= 50 ? "#D97706" : "#DC2626"); }

  function loadContent() {
    GS.api("/plugin/content-resonance/content?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      var rows = q("rows"), head = q("headline");
      if (!d.page_count) {
        head.hidden = true;
        rows.innerHTML = '<tr><td colspan="6" class="cr-empty">' + esc(d.note || TR('conten.f2.no_page_behaviour_in_this_range_ye')) + "</td></tr>";
        return;
      }
      head.hidden = false;
      var sc = q("score"); sc.textContent = d.resonance; sc.style.color = resColor(d.resonance);
      var mix = d.mix || {};
      q("mix").innerHTML = [["resonates", TR('conten.g.resonates')], ["confuses", TR('conten.g.confusing')], ["skimmed", TR('conten.g.skimmed')], ["neutral", TR('conten.g.neutral')]]
        .map(function (m) { return '<div class="cr-mixcell ' + m[0] + '"><div class="cr-mixn">' + num(mix[m[0]] || 0) + '</div><div class="cr-mixl">' + m[1] + "</div></div>"; }).join("");
      function crRow(p) {
        return '<tr data-path="' + esc(p.path) + '">' +
          '<td><div class="cr-path" title="' + esc(p.path) + '">' + esc(p.path) + "</div></td>" +
          '<td class="num"><div class="cr-resbar"><span class="cr-resmini"><i style="width:' + p.resonance + "%;background:" + resColor(p.resonance) + '"></i></span><span class="cr-resnum">' + p.resonance + "</span></div></td>" +
          '<td><span class="cr-verdict ' + esc(p.verdict) + '">' + esc(p.verdict_label) + "</span></td>" +
          '<td class="num">' + p.attention + "</td><td class=\"num\">" + p.frustration + "</td><td class=\"num\">" + num(p.sessions) + "</td></tr>";
      }
      if (window.GSMore) GSMore.mount({ container: rows, table: true, colspan: 6, items: d.pages, pageSize: 20, emptyText: TR('conten.f2.no_page_behaviour_in_this_range'), render: crRow });
      else rows.innerHTML = d.pages.map(crRow).join("");
      // Delegated: rows revealed by "Load more" stay selectable.
      if (!rows._crDelegated) { rows._crDelegated = 1;
        rows.addEventListener("click", function (e) { var tr = e.target.closest && e.target.closest("tr[data-path]"); if (tr) selectRow(tr.getAttribute("data-path")); }); }
    });
  }

  function selectRow(path) {
    Array.prototype.forEach.call(root.querySelectorAll(".cr-table tr"), function (tr) { tr.classList.toggle("sel", tr.getAttribute("data-path") === path); });
    loadDetail(path);
  }

  function loadDetail(path) {
    if (!path) return;
    var host = q("detail");
    host.innerHTML = '<div class="cr-empty">Loading&hellip;</div>';
    GS.api("/plugin/content-resonance/get?" + siteParam() + "&path=" + encodeURIComponent(path) + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      if (!d.sessions) { host.innerHTML = '<div class="cr-empty">' + esc(d.note || TR('conten.f2.no_detail_for_this_page')) + "</div>"; return; }
      var devs = (d.devices || []).map(function (v) {
        return '<div class="cr-dev"><span class="dv">' + esc(v.device) + '</span><span class="ds">' + num(v.sessions) + ' sess</span>' +
          '<span class="da"><span class="da">att <b>' + v.attention + '</b></span><span class="df">frust <b>' + v.frustration + "</b></span></span></div>";
      }).join("");
      host.innerHTML =
        '<div class="cr-dpath">' + esc(d.path) + "</div>" +
        '<div class="cr-dsum">' + esc(d.summary) + " <span class=\"cr-verdict " + esc(d.verdict) + '">' + esc(d.verdict_label) + "</span></div>" +
        '<div class="cr-dmetrics">' +
          '<div class="cr-dm"><b style="color:' + resColor(d.resonance) + '">' + d.resonance + "</b><span>" + TR('conten.g.resonance') + "</span></div>" +
          '<div class="cr-dm"><b>' + d.attention + "</b><span>" + TR('conten.g.attention') + "</span></div>" +
          '<div class="cr-dm"><b>' + d.frustration + "</b><span>" + TR('conten.g.frustration') + "</span></div>" +
          '<div class="cr-dm"><b>' + d.scroll + "%</b><span>" + TR('conten.g.scroll') + "</span></div></div>" +
        (devs ? '<div class="cr-dlabel">'+TT('cr.js.by_device')+'</div>' + devs : "");
    });
  }

  ready(function () {
    var f = q("from"), t = q("to");
    _rpInit();
    loadContent();
    var p = new URLSearchParams(location.search).get("path");
    if (p) loadDetail(p);
  });
})();
